import UserForm from "../form/Form";
import { MainPadding } from "../../../styles/Main.styles";
import { useLocation } from "react-router";
import {
  usePostAddUser,
  usePatchUser,
  useGetUserDetail,
} from "../network/resolver";
import { IModelUser } from "../type/user.http";

interface IUserFormView {
  onClose(): void;
}

export default function UserFormViewer({ onClose }: IUserFormView) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idUserParam = queryParams.get("id");
  const { mutate: mutateAdd, isLoading: loadingAdd } = usePostAddUser();
  const { mutate: mutateUpdate, isLoading: loadingUpdate } = usePatchUser();
  const { data: dataRawUser, isLoading: loadingFetch } = useGetUserDetail({
    user_id: idUserParam,
  });
  const dataUser = dataRawUser?.data.data;
  const loading = loadingAdd || loadingUpdate;

  const handleOnSubmit = (data: IModelUser) => {
    if (!idUserParam) {
      mutateAdd({ ...data });
    } else {
      mutateUpdate({ ...data });
    }
  };

  return (
    <MainPadding>
      <UserForm
        id={idUserParam || undefined}
        email={dataUser?.email}
        name={dataUser?.name}
        role={dataUser?.role}
        isFetching={loadingFetch}
        isLoading={loading}
        onClose={() => onClose()}
        onSubmit={(e) => handleOnSubmit(e)}
      />
    </MainPadding>
  );
}
